import FooterLinks from './FooterLinks';

export default FooterLinks;